<template>
    <div v-if="campaigns.length > 0" class="pb-4">
        <div class="text-tc-gray-3 text-24 mb-4 pt-4">{{lbl.home.deals_foryou}}</div>
        <div class="splide custom-slide" id="flashdeal-slide">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide"
                        v-for="(campaign, k) in campaigns"
                        :key="k"
                        @click="clickCampaign(campaign.id)">
                        <div class="border border-tc-gray-4 rounded-md overflow-hidden cursor-pointer bg-white">
                            <!-- <div class="campaign-image" :style="{'background-image': `url('${campaign.fullImageUrl}')`}"></div> -->
                            <div class="w-full h-32">
                                <img class="h-full w-full mx-auto" :src="campaign.fullImageUrl" />
                            </div>
                            <div class="px-4 py-2">
                                <div class="text-20 text-tc-gray-3 text-2-line h-12">{{campaign.name}}</div>
                            </div>
                            <div class="px-4">
                                <div class="border-t border-tc-gray-4 py-2 flex items-center">
                                    <div class="text-tc-blue-1 text-18 sm:text-25 font-bold">{{FilterNumberFormat(campaign.pricePerUnit ?? 0)}}</div>
                                    <div class="ml-2 text-tc-gray-3 text-18 sm:text-22">บาท</div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
//library
import Splide from '@splidejs/splide'; //https://splidejs.com/
//helper
import Locale from "@/helper/locale/Locale.js";
//service
import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";
import LocaleMixin from '@/mixin/LocaleMixin';

/**
 * @event onLoaded
 */
export default {
    name: "DashboardSlider",
    mixins: [LocaleMixin],
    props: {
        initListConfig:     { type: Object, required: true },
        initFilterConfig:   { type: Object, required: true },
        modalController:    { type: Object }
    },
    data: function() {
        return {
            listConfig: null,
            filterConfig: null,

            campaigns: [],

            isLoading: false,
            isLoaded: false,
            isHaveItem: false,
        };
    },
    created: function() {
        // this.getDashboard();
        this.listConfig = this.initListConfig;
        this.filterConfig = this.initFilterConfig;

        this.getList();
    },
    methods: {

        reinitList: function(listConfig, listFilter) {
            this.listConfig = listConfig;
            this.filterConfig = listFilter;
            this.campaigns = [];
            this.getList();
        },
        getList: function() {
            return new Promise((resolve) => {
                this.isLoading = true;
                BzbsCampaign.apiGetCampaign(this.listConfig, this.filterConfig).subscribe((campaigns) => {
                    // //! only debug
                    // if (ConfigManager.isDebugMode()) {
                    //     campaigns = [];
                    // }
                    this.listConfig.intSkip += this.listConfig.defaultTopAmount;
                    //check is there are more campaign.
                    if (campaigns && campaigns.length < this.listConfig.defaultTopAmount) {
                        this.listConfig.isSeeMoreEnable = false;
                    }

                    //reinitialize list if no skip.
                    if (this.listConfig.intSkip == this.listConfig.defaultTopAmount) {
                        this.campaigns = [];
                    }

                    for (var campaign of campaigns) {
                        //TODO: Add GA Tracking.
                        this.campaigns.push(campaign);
                    }

                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = this.campaigns.length > 0
                        ? true
                        : false;
                    this.setSliderFlashdeal();
                    console.log("this.campaigns", this.campaigns);
                    resolve();
                    this.$emit('onLoaded');
                }, (err) => {
                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.errorApi(err);

                    this.$emit('onLoaded');
                    resolve();
                });
            });
        },
        getDashboard: function() {
            var configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            var params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(params, 'dhipaya_dashborad').subscribe((data) => {
                this.arrDashboard = data.length ? data[0].subCampaignDetails : [];
                this.setSlider();

                this.$emit('onLoaded');
            }, (err) => {
                this.$emit('onLoaded');
                console.log(err);
            });
        },
        clickDashboard: function(dashboard) {
            if (dashboard.type == 'link') {
                window.open(dashboard.url, '_blank');
            } else if (dashboard.type == 'campaign') {
                this.$router.push('/campaign/' + dashboard.id);
            } else if (dashboard.type == 'cat') {
                this.$router.push('/campaign/' + dashboard.cat);
            }
        },
        clickCampaign: function(id) {
            this.$router.push('/campaign/' + id);
        },
        setSliderFlashdeal: function() {
            this.$nextTick(() => {
                new Splide('#flashdeal-slide', {
                    type: 'slide',
                    arrows: false,
                    padding: 0,
                    gap: 10,
                    perPage: 4,
                    breakpoints: {
                        830: {
                            perPage: 3,
                        },
                        420: {
                            perPage: 2,
                        },
                    }
                }).mount();
            });
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    .campaign-image {
        @include boxRatio($ratio: 50%);
    }
    .point-icon {
        width: 14px;
    }
</style>
<style lang="scss">
    @import "@/style/base/base.scss";

    .splide.custom-slide {
        .splide__pagination {
            bottom: -25px;

            .splide__pagination__page {
                border-radius: 50px;
                opacity: 1;
                background: $color-gray-2;
                transition: width .5s;
                margin: 2px;
                width: 8px;
                height: 8px;

                @include mobile {
                    margin: 2px;
                    width: 8px;
                    height: 8px;
                }

                &.is-active {
                    margin: 2px;
                    width: 19px;
                    height: 8px;
                    background: #1c3e95;
                    transform: unset;

                    @include mobile {
                        // background: #eb1c24;
                        background: #1c3e95;
                        margin: 4px;
                        width: 20px;
                        height: 8px;
                    }
                }
            }
        }
    }
</style>
